import { useEffect, useRef } from 'react';
import { onRateLimit } from '../lib/http';
import { useToast } from './ui/Toast';

const COOLDOWN_MS = 20000;

export default function RateLimitToastBridge() {
  const { info } = useToast();
  const lastShownRef = useRef(0);

  useEffect(() => {
    const off = onRateLimit(() => {
      const now = Date.now();
      if (now - lastShownRef.current < COOLDOWN_MS) return;
      lastShownRef.current = now;
      info(
        'Were slowing requests to keep things stable',
        'Some actions may retry automatically. If this persists, please slow down or close extra tabs.'
      );
    });
    return () => off();
  }, [info]);

  return null;
}
